import(/* webpackMode: "eager" */ "/Users/yoko/renehuemer.com/website/src/app/work/[categorySlug]/error.tsx");
